import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Button from "nlib/ui/Button";
import FormContext from "contexts/FormContext";
import Objects from "utils/Objects";
import React, { useCallback, useContext, useMemo } from "react";

const Buttons = (props) => {
  const {
    disabled,
    submitDisabled,
    initialValues,
    customPrompts,
    initialCustomPrompts,
    onSubmit,
    onCancel
  } = props;

  const { uiTexts } = useSelector(getTextsData);

  const { values } = useContext(FormContext);

  const settingsChanged = useMemo(() => {
    return !Objects.checkDeepEqualityByProps(initialValues, values);
  }, [initialValues, values]);

  const customPromptsChanged = useMemo(() => {
    return !Objects.checkDeepEqualityByProps(customPrompts, initialCustomPrompts);
  }, [customPrompts, initialCustomPrompts]);

  const handleCancelClick = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleSubmitClick = useCallback(() => {
    onSubmit({ settingsChanged, customPromptsChanged });
  }, [settingsChanged, customPromptsChanged, onSubmit]);

  return (
    <>
      <Button
        primary large
        disabled={disabled || submitDisabled || (!settingsChanged && !customPromptsChanged)}
        onClick={handleSubmitClick}>
        {uiTexts.save}
      </Button>
      <Button
        large outline
        disabled={disabled}
        onClick={handleCancelClick}>
        {uiTexts.cancel}
      </Button>
    </>
  );
};

export default React.memo(Buttons);
